module.exports = __webpack_public_path__ + "img/3e88d652aaabff89e42ab681c484faec.png";